<script setup lang="ts">
import InputToggleGroup from '@/components/input-toggle-group.vue'
import IconHelp from '@/shared/components/IconHelp.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDatabase } from '@fortawesome/pro-regular-svg-icons'
import { formatToMainCurrency } from '@/helpers/formatting'

defineProps<{ savings: number, savingsToDate: number, amountExcTax: number }>()

const show = defineModel('show')
</script>

<template>
  <div>
    <div :class="$style.toggle">
      <InputToggleGroup :options="[{ text: 'Show', value: true }, { text: 'Hide', value: false }]" v-model:selected="show" />
      <IconHelp :tooltip="`Show or hide this\nsection on the invoice.`" />
    </div>
    <div :class="$style.wrapper">
      <div :class="$style.title">Summary</div>

      <div :class="$style.values">
        <div class="d-flex align-items-center me-4">
          <div class="d-grid" style="grid-template-columns: 1fr max-content; column-gap: 50px;">
            <span>This invoice's savings</span>
            <span class="opacity-50">{{ formatToMainCurrency(savings) }}</span>

            <span>Savings to date</span>
            <span class="opacity-50">{{ formatToMainCurrency(savingsToDate) }}</span>

            <span>Total solar cost (excl)</span>
            <span class="opacity-50">{{ formatToMainCurrency(amountExcTax) }}</span>
          </div>
          <div class="position-relative ms-4">
            <FontAwesomeIcon :icon="faDatabase" :class="$style.icon" class="ms-2 fa-3x position-absolute" style="background: ;left: -9px; top: -13px; z-index: 7" />
            <FontAwesomeIcon :icon="faDatabase" :class="$style.icon" class="ms-2 fa-3x position-absolute" style="left: 5px; top: -20px; z-index: 5" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style module lang="scss">
$background: #eee;

.values {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;

  .icon {
    color: #ffffff66;
    background: $background;
  }
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  gap: 10px;
}

.wrapper {
  width: 408px;
  height: 106px;
  box-shadow: 2px 2px 4px #00000029;
  background: $background;
  position: relative;

  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: center;
  border-radius: 10px;
}

.title {
  position: absolute;
  top: 0;
  left: 8%;
  transform: translateY(-50%);
  background: #6d6e71;
  border-radius: 6px;
  padding: 10px 18px;
  color: #fff;
  text-transform: uppercase;
}
</style>
